/* eslint-disable no-undef */
APP.TopBar = function (containerSelector) {
  this.container = document.querySelector(containerSelector);
  this.osClass = APP.utils.getClientOsClass();
  this.firstSlide = document.querySelector('.swiper-slide');

  this._renderLinks();
  window.addEventListener('scroll', this._topBarScroll.bind(this));
};

APP.TopBar.prototype._renderLinks = function () {
  // eslint-disable-next-line no-unused-vars
  var backLink = document.querySelector('header .back-link');
  var title = document.querySelector('.column.title h1');
  var storeLinks = document.querySelector('.store-links');

  if (title && storeLinks) {
    this.container.appendChild(title.cloneNode(true));
    var storeLinksCopy = storeLinks.cloneNode(true);
    storeLinksCopy.style.visibility = 'visible';
    this.container.appendChild(storeLinksCopy);
  }
  var platforms = Array.prototype.slice.call(this.container.querySelectorAll('.store-links li'));

  if (this.osClass) {
    this.container.querySelector('.store-links').classList.add('mobile');

    platforms.forEach(function (link) {
      link.querySelector('.txt').innerHTML = 'Stáhnout';
    });
    APP.DetailPage.showActualPlatformLink(platforms, this.osClass, 'topBar');
  } else {
    this.container.querySelector('.store-links').classList.add('desktop');
  }
};

APP.TopBar.prototype._topBarScroll = function () {
  var backLink = document.querySelector('.back-link');
  var backLinkText = document.querySelector('.back-link span');

  if (this.firstSlide.getBoundingClientRect().top < -300) {
    APP.TopBar.topBarSwitch(this.container, true);
    backLink.classList.add('scrolled');
    backLinkText.classList.add('hidden');
  } else {
    APP.TopBar.topBarSwitch(this.container, false);
    backLink.classList.remove('scrolled');
    backLinkText.classList.remove('hidden');
  }
};

APP.TopBar.prototype.topBarSwitch = function (visibility) {
  APP.TopBar.topBarSwitch(this.container, visibility);
};

APP.TopBar.prototype.getContainer = function () {
  return this.container;
};

APP.TopBar.topBarSwitch = function (topBar, visibility) {
  if (visibility) {
    topBar.classList.add('visible');
  } else {
    topBar.classList.remove('visible');
  }
};
